import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => setOpen(false), [loc]);


  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner">
        <Link to="/" className="nav__brand">
          {/* ── LOGO IMAGE ──
              Replace /images/logo.jpeg with your actual logo file path.
              The image must be in frontend/public/images/ folder.
              Example: if logo file is "nativeroots-logo.png", use /images/nativeroots-logo.png
          */}
          <img src="/images/logo.jpeg" alt="Nativeroots" className="nav__logo" />
          <span className="nav__wordmark">Nativeroots</span>
        </Link>

        <nav className={`nav__links ${open ? 'nav__links--open' : ''}`}>
          <NavLink to="/"         className={({isActive}) => 'nav__link' + (isActive ? ' nav__link--active' : '')}>Home</NavLink>
          <NavLink to="/products" className={({isActive}) => 'nav__link' + (isActive ? ' nav__link--active' : '')}>Products</NavLink>
          <NavLink to="/export-deck" className={({isActive}) => 'nav__link' + (isActive ? ' nav__link--active' : '')}>Export and Distribution</NavLink>
          <Link to="/contact" className="nav__btn">Contact and Request Details</Link>
        </nav>

        <button className={`nav__burger ${open ? 'nav__burger--x' : ''}`} onClick={() => setOpen(o => !o)} aria-label="Menu">
          <span/><span/><span/>
        </button>
      </div>
    </header>
  );
}
